export default __webpack_public_path__ + "static/media/homebg.505c3b5d.png";